import {
  DELETE_FAVORITE,
  ERROR_DELETE_FAVORITE,
  ERROR_GET_MY_FAVORITES,
  GET_MY_FAVORITES,
  SUCESS_DELETE_FAVORITE,
  SUCESS_GET_MY_FAVORITES} from '../constants';

const initialState = {
  content: [],
  totalPages: 0,
  totalElements: 0,
  last: true,
  first: true,
  size: 5,
  number: 0,
  sort: null,
  numberOfElements: 0,

  loading: false,
  error: false,

  deleting: false,
  errorDeleting: false
};

const myFavoritesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MY_FAVORITES:
      return {
        ...state,
        loading: true
      };
    case SUCESS_GET_MY_FAVORITES:
      return {
        ...state,
        ...action.data,
        loading: false
      };
    case ERROR_GET_MY_FAVORITES:
      return {
        ...state,
        content: initialState.content,
        totalPages: initialState.totalPages,
        totalElements: initialState.totalElements,
        last: initialState.last,
        first: initialState.first,
        size: initialState.size,
        number: initialState.number,
        sort: initialState.sort,
        numberOfElements: initialState.numberOfElements,
        loading: false,
        error: true
      };
    case DELETE_FAVORITE:
      return {
        ...state,
        deleting: true
      };
    case SUCESS_DELETE_FAVORITE:
      return {
        ...state,
        deleting: false
      };
    case ERROR_DELETE_FAVORITE:
      return {
        ...state,
        deleting: false,
        errorDeleting: true
      };
    default:
      return state;
  }
};
export default myFavoritesReducer;
